import { Skeleton } from '@/components/ui/skeleton';

export function OrdersListSkeleton(): React.JSX.Element {
  return (
    <div data-testid="orders-list-skeleton" className="space-y-6">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-10 w-[240px] rounded-xl" />
        <Skeleton className="rounded-btn h-8 w-[120px]" />
      </div>

      {/* Toolbar skeleton */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
        <Skeleton className="rounded-input h-10 w-full max-w-md" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-[72px] rounded" />
          <Skeleton className="h-6 w-12 rounded" />
          <Skeleton className="h-6 w-12 rounded" />
          <Skeleton className="h-6 w-12 rounded" />
          <Skeleton className="h-6 w-12 rounded" />
          <Skeleton className="h-6 w-12 rounded" />
        </div>
      </div>

      {/* Table skeleton (desktop) */}
      <div className="border-border bg-card shadow-admin-card hidden overflow-hidden rounded-lg border md:block">
        <div className="bg-admin-surface-muted border-border flex h-10 items-center border-b">
          <div className="flex w-full items-center gap-8 px-4">
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-5 w-16 rounded" />
            <Skeleton className="h-4 w-20 rounded" />
            <Skeleton className="h-4 w-10 rounded" />
            <Skeleton className="h-4 w-20 rounded" />
            <div className="flex flex-col gap-1">
              <Skeleton className="h-4 w-[140px] rounded" />
              <Skeleton className="h-3 w-[100px] rounded" />
            </div>
          </div>
        </div>
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className="border-border flex h-14 items-center border-b px-4 last:border-b-0"
          >
            <div className="flex w-full items-center gap-8">
              <Skeleton className="h-4 w-4 rounded-full" />
              <Skeleton className="h-5 w-16 rounded" />
              <Skeleton className="h-4 w-20 rounded" />
              <Skeleton className="h-4 w-10 rounded" />
              <Skeleton className="h-4 w-20 rounded" />
              <div className="flex flex-col gap-1">
                <Skeleton className="h-4 w-[140px] rounded" />
                <Skeleton className="h-3 w-[100px] rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Card skeleton (mobile) */}
      <div className="flex flex-col gap-3 md:hidden">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="border-border bg-card shadow-admin-card rounded-lg border p-4">
            <div className="mb-3 flex items-center justify-between">
              <Skeleton className="h-5 w-20 rounded" />
              <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <Skeleton className="mb-1 h-4 w-[140px] rounded" />
            <Skeleton className="mb-2 h-3 w-[100px] rounded" />
            <div className="flex items-center justify-between">
              <Skeleton className="h-3 w-24 rounded" />
              <Skeleton className="h-4 w-16 rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
